import React, { Fragment } from 'react';
import i18n from 'src/utils/translate';
import { useSelector } from 'react-redux';
import ReactHtmlParser from 'react-html-parser';
import styled from 'styled-components';
import { titleMedium } from 'styles-js/mixins/typography';

const NHSContainer = styled.div`
  h1, h2, h3, h4, h5, h6 {
    ${titleMedium};
    margin-top: 20px;
  }
  p {
    margin-bottom: 10px;
  }
  ul {
    list-style: none;
    padding: 0;
    margin: 0;
    margin-bottom: 20px;
    li {
      padding-left: 1em;
      text-indent: -.7em;
      ::before {
        content: "• ";
        color: ${props => props.theme.colorGreen};
      }
    }
  }
  .modal-content & {
    padding: 40px 50px;
    overflow: auto;

    @media (${props => props.theme.underScreenSmall}) {
      padding: 30px 40px;
    }
    @media (${props => props.theme.underScreenXxsmall}) {
      padding: 30px 20px;
    }
    p {
      margin-bottom: 20px;
    }
    p:last-of-type {
      margin-bottom: 50px;
    }
  }
`;

const Logo = styled.img`
  margin: 20px 0;
  width: 100%;
`;
const AttributionText = styled.p`
  color: ${({theme}) => theme.colorGreyDark};
`;



const NHSContent = () => {

  const attributionLogo: string = useSelector((state: any) => state.pages.tag.NHS.attributionLogo);
  const attributionUrl: string = useSelector((state: any) => state.pages.tag.NHS.attributionUrl);
  const trackingPixel: string = useSelector((state: any) => state.pages.tag.NHS.trackingPixel);
  const content: string = useSelector((state: any) => state.pages.tag.NHS.content);

  function transform(node: any) {
    if (node.type === 'tag' && node.name === 'a') {
      let href = node.attribs.href;
      if (node.attribs.href.includes('api.')) {
        href = node.attribs.href.replace('api.', 'www.');
      } else if (node.attribs.href.startsWith('/')) {
        href = `https://www.nhs.uk${node.attribs.href}`;
      }
      node.attribs = {
        ...node.attribs,
        href,
        target: '_blank',
        rel: 'noopener noreferrer',
      };
    }
  }
  const Content = () => (
    <Fragment>
      {ReactHtmlParser(content, {transform})}
    </Fragment>
  );


  const Attribution = () => (
    <Fragment>
      <a href={attributionUrl} rel="noopener noreferrer"
        target="_blank">
        <Logo src={attributionLogo}/>
      </a>
      <AttributionText>{i18n.t('HealthUnlocked contains information from NHS Digital, licensed under the current version of the Open Government Licence')}</AttributionText>
    </Fragment>
  );

  const TrackingPixel = () => (
    <Fragment>
      {ReactHtmlParser(trackingPixel)}
    </Fragment>
  );

  return (
    <NHSContainer>
      <Content/>
      <Attribution/>
      <TrackingPixel/>
    </NHSContainer>
  );
};

export default NHSContent;
